import React, { useState } from 'react'

import { resetResults } from '../dashboard-slice'
import { selectExamCards } from '../selectors'

import style from './ResetButton.module.css'

import { ReactComponent as ResetIcon } from 'assets/icons/reset-icon.svg'
import { ConfirmModal, IconButton } from 'common/components'
import { useAppDispatch, useAppSelector } from 'common/hooks'

export const ResetButton = () => {
  const dispatch = useAppDispatch()
  const cards = useAppSelector(selectExamCards)
  const [isResetModalOpen, setIsResetModalOpen] = useState(false)

  const isNewbie = cards.every(tech => tech.attempts === 0)

  const resetResultsHandler = () => {
    dispatch(resetResults())
  }

  return (
    <>
      <IconButton
        callback={() => setIsResetModalOpen(true)}
        title="Сбросить результат"
        disabled={isNewbie}
      >
        <ResetIcon className={style['info-icon']} />
      </IconButton>
      <ConfirmModal
        title="Сброс результатов"
        isOpen={isResetModalOpen}
        message="Вы уверены, что хотите сбросить результаты всех тестов?"
        onClose={() => setIsResetModalOpen(false)}
        callback={resetResultsHandler}
      />
    </>
  )
}
